module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "fm-09-ingredients-text"
    }
  }, [_c('p', {
    staticClass: "top-bar",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style-2"
  }, [_c('img', {
    staticClass: "generated-style-2",
    attrs: {
      "alt": "IcePops_TopBar_Orange.gif",
      "src": "Images/IcePops_TopBar_Orange_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "recipe-heading",
    attrs: {
      "id": "toc-anchor",
      "xml:lang": "en-us"
    }
  }, [_vm._v("ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Simple to make, ice pops feature few ingredients, so it’s important to select the best. From the fruit juice, to the block of chocolate, to the jug of milk, be sure to seek out high-quality products for the most appealing taste and texture.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("fruit")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Fresh fruit stars in colorful and flavor-packed ice pops. Some recipes will simply call for fruit juice; others will call for puréeing freshly chopped pieces; and still others will suggest warming the fruit in a saucepan to release and concentrate the flavors. Regardless of the method, seek out the highest quality fruit you can find, buying it in its peak season whenever possible. In a pinch, you can use high-quality, unsweetened frozen fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("dairy")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("For dairy-based ice pops, creaminess is achieved through the use of a number of ingredients, including milk, cream, half-and-half, yogurt, buttermilk, and even rice milk. Use full-fat milk or yogurt unless advised otherwise, as a reduced fat content may result in an overly icy final texture. Use large grade A eggs, as fresh as you can find, to achieve the desired luscious consistency in the finished pop.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("flavorings")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The flavoring options for ice pops are nearly endless. Classic choices include high-quality chocolate and cocoa powder; vanilla beans or extract; and a wide array of nuts. Fresh herbs, such as mint and basil, and dried spices, like cinnamon and cloves, bring exciting new tastes to the genre. Keep in mind that flavors can dull slightly with freezing, meaning you may want to err slightly stronger than you would in other types of recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "method-subhead",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("liquids")]), _vm._v(" "), _c('p', {
    staticClass: "body-copy",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("The liquid ingredients that you choose for your pops will also affect their outcome. If your tap water has a pronounced flavor, consider using spring or filtered water instead. Tea, coffee, wine, and liquor can also deliver bold flavor to ice pops. Observe the quantities for alcohol, as larger amounts can inhibit freezing. Check manufacturers’ instructions before using carbonated liquids in instant ice pop makers.")]), _vm._v(" "), _c('p', {
    staticClass: "bottom-bar",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('span', {
    staticClass: "generated-style-2"
  }, [_c('img', {
    staticClass: "generated-style-2",
    attrs: {
      "alt": "IcePops_TopBar_Orange.gif",
      "src": "Images/IcePops_TopBar_Orange_fmt1.jpeg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05836aa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FM_09_Ingredients_text.vue
// module id = 72
// module chunks = 0